import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
export const useMyOrgStore = defineStore('my-org-store', () => {
  const state = reactive({
    orgList: [],
    isLoading: false
  });
  const {
    runAsync: getMyOrgListApi
  } = fetchApi('org.getMyOrgList');
  const setMyOrgList = rows => {
    state.orgList = rows || [];
    state.isLoading = true;
  };
  const getMyOrgList = async (skipId = '') => {
    const {
      rows,
      error
    } = await getMyOrgListApi({});
    if (error) return [];
    setMyOrgList(rows);
    if (skipId) {
      return (rows || []).filter(t => t.id !== skipId);
    }
    return rows || [];
  };
  const resetList = () => {
    state.isLoading = false;
  };
  const clear = () => {
    state.isLoading = false;
    state.orgList = [];
  };
  return {
    state,
    resetList,
    getMyOrgList,
    clear,
    $reset: clear
  };
});